import React, { memo, useState, useEffect } from 'react'
import { Grid } from '@material-ui/core'
import { Controller } from 'react-hook-form'

import * as Style from './styles'

import { verifyIndicationCodeInput } from 'redux/api/user'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { IndicationField } from '../IndicationField'
import { MultiCharInput } from '../../../../components/MultiCharInput'

function IndicationData({ control, watch, setError, clearErrors, errors }) {
    const { t } = useTranslation()
    const watchIndication = watch('IndicatorCode')

    useEffect(() => {
        if (watchIndication?.length === 6) {
            verifyIndicationCodeInput(watchIndication).then((response) => {
                if (!response) {
                    setError('IndicatorCode', {
                        type: 'manual',
                        message: t('Invalid code'),
                    })
                } else {
                    clearErrors('IndicatorCode')
                }
            })
        }
    }, [watchIndication])

    return (
        <Style.Container container xs={12} md={12} spacing={2}>
            <Grid item xs={12}>
                <Box
                    component="strong"
                    textTransform="uppercase"
                    style={{ color: '#1f1f1f', fontWeight: 600 }}
                >
                    {t('WAS_IT_REFERRED_BY')}
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Controller
                    as={
                        <MultiCharInput
                            title={t('ENTER_THE_PARTICIPANT_CODE_AND_BENEFIT')}
                            amount={6}
                            errors={{
                                message: errors?.IndicatorCode?.message,
                                status: !!errors?.IndicatorCode,
                            }}
                        />
                    }
                    defaultValue=""
                    name="IndicatorCode"
                    control={control}
                    id="IndicatorCode"
                />
            </Grid>
        </Style.Container>
    )
}

export default memo(IndicationData)
